import React, { useEffect, useState } from 'react';
import { Animated, Easing } from 'react-native';
import { Constants } from '../../../utils';

type Props = {
  readonly children: React.ReactNode;
  readonly delay?: number;
  readonly duration?: number;
  readonly removeAfter?: boolean;
  readonly direction?: 'in' | 'out';
};

const isTest = !!process.env.JEST_WORKER_ID;

export const Fade = ({ children, delay = 0, duration = 1500, removeAfter = true, direction = 'in' }: Props) => {
  // Create the Animated.Value once for the component's lifetime (initial direction only),
  // matching the previous useRef(new Animated.Value(...)) behavior.
  const [opacity] = useState(() => new Animated.Value(direction === 'in' ? 0 : 1));
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (isTest) return;

    setTimeout(() => {
      if (direction === 'in') {
        Animated.timing(opacity, {
          toValue: 1,
          duration,
          easing: Easing.linear,
          useNativeDriver: Constants.shouldUseNativeDriver,
        }).start();
      } else {
        Animated.timing(opacity, {
          toValue: 0,
          duration,
          easing: Easing.linear,
          useNativeDriver: Constants.shouldUseNativeDriver,
        }).start(({ finished }) => {
          if (removeAfter && finished) {
            setShow(false);
          }
        });
      }
    }, delay);
  }, [direction, opacity, delay, duration, removeAfter]);

  return show ? (
    <Animated.View
      style={{
        opacity,
      }}
    >
      {children}
    </Animated.View>
  ) : null;
};
